import React, {useEffect, useState} from "react";
import PresetInterface from "../../interfaces/PresetInterface";
import "./styles/Table.css"
import GetItemValue from "./functions/GetItemValue";
import GetItemsSum from "./functions/GetItemsSum";
import GetItemsSale from "./functions/GetItemsSale";
import GetItemsVat from "./functions/GetItemsVat";
import GetItemsFinish from "./functions/GetItemsFinish";
import axios from "axios";
// import Modal from "../Modal";
import useWindowSize from "../../hooks/useWindowSize";
import {Button, Dialog, Field, Input} from "@mrocket/ui";
import {DialogActions} from "@mrocket/ui/lib/Dialog/Dialog.styles";

const Table: React.FC<{ preset: PresetInterface }> = (props) => {

  const [thWidths, setThWidths] = useState<{ [key: string]: number }>({})
  const [isDisableCall, setIsDisableCall] = useState<boolean>(false)
  const [invoiceModal, setInvoiceModal] = useState(false)
  const [invoiceEmail, setInvoiceEmail] = useState("")
  const [modalInfo, setModalInfo] = useState({
    active: false,
    title: "",
    text: ""
  })
  const windowSize = useWindowSize()

  useEffect(() => {

    let gotCall = window.localStorage.getItem("lastCall")

    if (gotCall) {
      if (JSON.parse(gotCall).expires > Date.now()) {
        setIsDisableCall(true)
      }
    }

    let allWidth = 0

    props.preset.fields.forEach((field) => {
      allWidth += field.width ?? 100
    })

    const AddW: { [key: string]: number } = {}

    props.preset.fields.forEach((field) => {
      AddW[field.id] = (field.width ?? 100) / allWidth * 100
    })
    setThWidths(AddW)
  }, [props.preset.fields]);

  const setCallHandler = async () => {
    if (isDisableCall) return false

    let callSettings = {
      expires: Date.now() + (1000 * 24 * 60),
    }

    const gotCall = window.localStorage.getItem("lastCall")

    if (gotCall) {
      if (JSON.parse(gotCall).expires > Date.now()) {

        return false
      }
    }

    window.localStorage.setItem("lastCall", JSON.stringify(callSettings))

    setIsDisableCall(true)
    const path = window.location.pathname.split("/")

    try {
      if (path[3]) {
        await axios.post(`https://products.amo.tools/table/api/call/${path[2]}/${path[3]}`)
      } else {
        await axios.post(`https://products.amo.tools/table/api/call/${path[2]}`)
      }

      setModalInfo({
        active: true,
        title: "Успех",
        text: "Заявка успешно отправлена"
      })
    } catch (e) {
      setModalInfo({
        active: true,
        title: "Ошибка",
        text: "Вы уже отправляли заявку на обратный звонок"
      })
    }
  }

  return (
    <>
      <Dialog
        open={modalInfo.active}
        title={modalInfo.title}
        icon={"phone.and.waveform.fill"}
        onClose={() => {
          setModalInfo({
            active: false,
            title: "",
            text: ""
          })
        }}>

        {modalInfo.text}

      </Dialog>

      <Dialog
        open={invoiceModal}
        title={"Укажите вашу почту для чека"}
        icon={"mail"}
        actions={[
          {
            action: () => {
              if (invoiceEmail.length > 0) {
                window.location.href = "/api/invoice/" + window.location.pathname.split("/")[2] + "?email=" + invoiceEmail
              }
            },
            autoClose: false,
            label: "Оплатить",
            mode: "primary"
          }
        ]}
        onClose={() => {
          setInvoiceModal(false)
        }}>
        <Input type={"email"} placeholder={"ivanov@mail.com"} value={invoiceEmail} onChange={(e) => setInvoiceEmail(e.target.value.trimStart())} />
      </Dialog>

      {
        windowSize[0] > 1023 ? (
          <table className="AmoTools__Table">
            <thead className="AmoTools__Table__Thead">
            <tr className="AmoTools__Table__Thead__TR">
              {
                props.preset.fields.map(field => {
                  return <th
                    style={{width: `${thWidths[field.id]}%`}}
                    key={`TheadTrKey-${field.id}`}
                    className="AmoTools__Table__Thead__TR__TH">
                    <div className="AmoTools__Table__Thead__TR__TH__Inner">
                      {field.name}
                    </div>
                  </th>
                })
              }
            </tr>
            </thead>

            <tbody>
            {
              props.preset.items.map((item, index) => {

                return <tr
                  className="AmoTools__Table__Tbody__TR"
                  key={item._id}
                >
                  {
                    props.preset.fields.map(field => {
                      let customField = item.custom_fields.filter((f) => f.id === field.id)

                      const value = GetItemValue({
                        preset: props.preset,
                        item: item,
                        field: field,
                        customField: customField,
                        index: index
                      })


                      return <td
                        className="AmoTools__Table__Tbody__TR__TD"
                        style={{width: `${thWidths[field.id]}%`}}
                        key={`${item._id}-${field.id}`}
                      >
                        <div className="AmoTools__Table__Tbody__TR__TD__Inner">
                          {value}
                        </div>
                      </td>
                    })
                  }
                </tr>

              })
            }
            </tbody>
          </table>
        ) : (
          <div className="AmoTools__MobileTable">
            {
              props.preset.items.map((item, index) => {
                return (
                  <div className="AmoTools__MobileTable__Item" key={item._id}>
                    {
                      props.preset.fields.map(field => {
                        let customField = item.custom_fields.filter((f) => f.id === field.id)

                        const value = GetItemValue({
                          preset: props.preset,
                          item: item,
                          field: field,
                          customField: customField,
                          index: index
                        })
                        return <div
                          className="AmoTools__MobileTable__Item__Field"
                          key={`${item._id}-${field.id}`}
                        >
                          <div className="AmoTools__MobileTable__Item__Field__Name">
                            {field.name}
                          </div>
                          <div className="AmoTools__MobileTable__Item__Field__Value">
                            {value}
                          </div>
                        </div>
                      })
                    }
                  </div>
                )
              })
            }
          </div>
        )
      }
      {
        props.preset.checkboxes.count === 0 ? "" :
          (
            <div className={`AmoTools__Resume ${windowSize[0] <= 1023 ? "AmoTools__Resume-Mobile" : ""}`}>
              {props.preset.checkboxes.sum ? (
                <div className="AmoTools__Resume__Line">
                  <div className="AmoTools__Resume__Line__Left">
                    Итого:
                  </div>
                  <div className="AmoTools__Resume__Line__Right">
                    {GetItemsSum(props.preset)} ₽
                  </div>
                </div>
              ) : ""}
              {props.preset.checkboxes.sale ? (
                <div className="AmoTools__Resume__Line">
                  <div className="AmoTools__Resume__Line__Left">
                    Скидка в сумме:
                  </div>
                  <div className="AmoTools__Resume__Line__Right">
                    {GetItemsSale(props.preset)} ₽
                  </div>
                </div>
              ) : ""}
              {props.preset.checkboxes.nds ? (
                <div className="AmoTools__Resume__Line">
                  <div className="AmoTools__Resume__Line__Left">
                    {
                      props.preset.checkboxes.nds === 1
                        ? "Не облагается НДС:"
                        : `НДС ${
                          [2, 3].indexOf(props.preset.checkboxes.nds) > -1
                            ? "10"
                            : (
                              [4, 5].indexOf(props.preset.checkboxes.nds) > -1
                                ? "20"
                                : (
                                  [6, 7].indexOf(props.preset.checkboxes.nds) > -1 ? "18" : ""
                                )
                            )

                        }% от суммы`
                    }
                  </div>
                  <div className="AmoTools__Resume__Line__Right">
                    {GetItemsVat(props.preset)} ₽
                  </div>
                </div>
              ) : ""}
              {props.preset.checkboxes.sum ? (
                <div className="AmoTools__Resume__Line">
                  <div className="AmoTools__Resume__Line__Left">
                                       <span className="AmoTools__Resume__Line__Left__Heading">
                                           Всего к оплате:
                                       </span>
                  </div>
                  <div className="AmoTools__Resume__Line__Right">
                                       <span className="AmoTools__Resume__Line__Right__Heading">
                                           {GetItemsFinish(props.preset)} ₽
                                       </span>
                  </div>
                </div>
              ) : ""}
            </div>
          )
      }

      {props.preset.text.length > 0 ?
        <div className={"AmoTools_UserText"} dangerouslySetInnerHTML={{__html: props.preset.text}}/> : ""}

      {
        props.preset.lead_fields.length > 0 || props.preset.set_task || window.location.pathname.split("/").length === 3
          ? (
            <div className="AmoTools__Buttons">
              {
                props.preset.lead_fields.map((field, index) => {
                  return <Button
                    as={"a"}
                    key={index}
                    // className="AmoTools__Buttons__Item"
                    target="_blank"
                    mode={"primary"}
                    appearance={"fill"}
                    href={field.values[0].value} rel="noreferrer">{field.field_name}</Button>
                })
              }
              {
                props.preset.set_task ?
                  <Button
                    appearance={"fill"}
                    mode={"success"}
                    disabled={isDisableCall}
                    onClick={setCallHandler}>
                    Запросить обратный звонок
                  </Button>
                  : ""
              }
              {
                window.location.pathname.split("/").length === 3 && props.preset.status && props.preset.status < 5 ?
                  (
                    // props.preset.canPay ? (
                    //     <Button className={"AmoTools__Buttons__Item--Buy"} as={"a"} mode={"primary"} appearance={"fill"} href={"/api/invoice/" + window.location.pathname.split("/")[2]}>
                    //       Оплатить
                    //     </Button>) :
                    //   (
                    //     <Button className={"AmoTools__Buttons__Item--Buy"} mode={"primary"} appearance={"fill"} disabled={true}>Оплатить</Button>
                    //   )
                    <Button className={"AmoTools__Buttons__Item--Buy"} mode={"primary"} appearance={"fill"} onClick={() => setInvoiceModal(true)} disabled={!props.preset.canPay}>Оплатить</Button>
                  )

                  : ""
              }
            </div>
          ) : ""
      }


    </>
  )
}

export default Table
